import { useState } from 'react';
import { Referencias } from './Referencias';
import { Descargadores } from './Descargadores';
import { useT } from '../i18n';

/**
 * La sección «Herramientas» del menú: lo que se usa PARA trabajar, no lo que se produce.
 *
 * ── Por qué Leads y Descargadores comparten sección ───────────────────────────
 * Porque las dos son insumos: una lista de cuentas ajenas de las que se saca referencia, y una
 * lista de utilidades de afuera. Ninguna de las dos habla de una influencer propia, que es lo
 * que separa esta sección de Estadísticas.
 *
 * ── Y por qué NO comparten pantalla ───────────────────────────────────────────
 * Porque un lead se mide —tiene seguidores, capturas periódicas, una razón para volver— y un
 * descargador es un enlace con nombre. En una sola tabla, la mitad de las columnas estarían
 * siempre vacías y «agregar» significaría dos cosas distintas según la fila.
 */
export function Herramientas() {
  const { t } = useT();
  const [panel, setPanel] = useState<'leads' | 'descargadores'>('leads');

  return (
    <div className="space-y-4">
      <div
        className="flex flex-wrap gap-1 rounded-xl border border-[var(--color-border-subtle)] bg-[var(--color-surface-sunken)] p-1"
        role="tablist"
        aria-label={t('nav.herramientas')}
      >
        {(
          [
            ['leads', t('nav.referencias')],
            ['descargadores', t('tab.descargadores')],
          ] as const
        ).map(([clave, etiqueta]) => (
          <button
            key={clave}
            type="button"
            role="tab"
            aria-selected={panel === clave}
            onClick={() => setPanel(clave)}
            className={`rounded-lg px-3 py-1.5 text-sm font-medium transition ${
              panel === clave
                ? 'bg-[var(--color-surface-raised)] text-[var(--color-ink)] shadow-sm'
                : 'text-[var(--color-ink-muted)] hover:text-[var(--color-ink)]'
            }`}
          >
            {etiqueta}
          </button>
        ))}
      </div>

      {/* Leads es la pantalla que ya existía, sin tocar: se movió de sitio, no se reescribió. */}
      {panel === 'leads' ? <Referencias /> : <Descargadores />}
    </div>
  );
}
